import { render, staticRenderFns } from "./FIBNextScreenTrigger.vue?vue&type=template&id=d90d0964&scoped=true&"
import script from "./FIBNextScreenTrigger.vue?vue&type=script&lang=js&"
export * from "./FIBNextScreenTrigger.vue?vue&type=script&lang=js&"
import style0 from "./FIBNextScreenTrigger.vue?vue&type=style&index=0&id=d90d0964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90d0964",
  null
  
)

export default component.exports